import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { useActiveCustomers } from '@/hooks/useCustomers';

export type EpcClientSelectProps = Omit<
  SelectProps<string>,
  'options' | 'loading' | 'showSearch' | 'optionFilterProp'
> & {
  /** Called with customer id and display name when selection changes */
  onClientChange?: (customerId: string | undefined, clientName: string | undefined) => void;
};

/**
 * EPC UI label "Client" — backed by Customer master (not free text).
 * EXACT_REUSE of useActiveCustomers / CRM party model.
 */
export const EpcClientSelect: React.FC<EpcClientSelectProps> = ({
  onClientChange,
  onChange,
  allowClear = true,
  placeholder = 'Select client',
  ...rest
}) => {
  const { data: customers = [], isLoading } = useActiveCustomers();

  const options = (customers || []).map((c) => ({
    label: c.customer_name,
    value: c.id,
  }));

  return (
    <Select
      {...rest}
      allowClear={allowClear}
      placeholder={placeholder}
      loading={isLoading}
      showSearch
      optionFilterProp="label"
      options={options}
      onChange={(value, option) => {
        onChange?.(value, option);
        if (onClientChange) {
          if (!value) {
            onClientChange(undefined, undefined);
            return;
          }
          const c = customers.find((x) => x.id === value);
          onClientChange(value, c?.customer_name);
        }
      }}
    />
  );
};

export default EpcClientSelect;
